import Need from "../Need";

export const NeedStructureListView = new Need('structure.list.view');
export const NeedStructureTreeView = new Need('structure.tree.view');
export const NeedStructureView = new Need('structure.view');
export const NeedStructureCreate = new Need('structure.create');
export const NeedStructureEdit = new Need('structure.edit');
export const NeedStructureDelete = new Need('structure.delete');
